module.exports = __webpack_public_path__ + "static/media/Gotham-Light.ef7f2f96.woff2";